import { Roles } from '@/models/role/Roles';
import { hasRoleAccess } from '@/utils/role.permission.helpers';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'main-home',
        component: () => import('@/components/general/MainLayout.vue'),
        children: [
            {
                path: '',
                sensitive: true,
                name: 'home',
                component: () => import('@/components/general/WorkerDeagrame.vue'),
            },
            {
                path: 'worker/:id',
                name: 'worker',
                component: () => import('@/components/general/WorkerPage.vue'),
            },
            {
                path: 'all-statistics',
                name: 'all-statistics',
                component: () => import('@/views/pages/Statistics/Statistics.vue'),
            },
            {
                path: '403',
                name: 'AccessDenied',
                meta: {
                    title: 'Access Denied',
                },
                component: () => import('@/views/AccessDenied.vue'),
            },
            {
                path: 'drivers',
                name: 'drivers',
                component: () => import('@/views/pages/Driver/Driver.vue'),
            },
            {
                path: 'driver/manage/:id?',
                name: 'driver-manage',
                component: () => import('@/views/pages/Driver/DriverManage.vue'),
            },
            {
                path: 'users',
                name: 'users',
                component: () => import('@/views/pages/User/User.vue'),
            },
            {
                path: 'user/manage/:id?',
                name: 'user-manage',
                component: () => import('@/views/pages/User/UserManage.vue'),
            },
            {
                path: 'roles',
                name: 'roles',
                component: () => import('@/views/pages/Role/Role.vue'),
            },
            {
                path: 'role/manage/:id?',
                name: 'role-manage',
                component: () => import('@/views/pages/Role/RoleManage.vue'),
            },
            {
                path: 'levels',
                name: 'levels',
                component: () => import('@/views/pages/Level/Level.vue'),
            },
            {
                path: 'level/manage/:id?',
                name: 'level-manage',
                component: () => import('@/views/pages/Level/LevelManage.vue'),
            },
            {
                path: 'checker',
                name: 'checker',
                component: () => import('@/views/pages/Checker/Checker.vue'),
            },
            {
                path: 'companies',
                name: 'companies',
                component: () => import('@/views/pages/Company/Company.vue'),
            },
            {
                path: 'company/manage/:id?',
                name: 'company-manage',
                component: () => import('@/views/pages/Company/CompanyManage.vue'),
            },
            {
                path: 'task-state',
                name: 'task-state',
                component: () => import('@/views/pages/Task/TaskState.vue'),
            },
            // {
            //     path: 'monitoring',
            //     name: 'monitoring',
            //     component: () => import('@/views/pages/Monitoring/Monitoring.vue'),
            // },
            {
                path: 'driver-activity',
                name: 'driver-activity',
                component: () => import('@/views/pages/Activity/DriverActivity.vue'),
            },
            {
                path: 'driver-activity-history', 
                name: 'driver-activity-history',
                component: () => import('@/views/pages/Activity/DriverActivityHistory.vue'), 
            },
            {
                path: 'kpi',
                name: 'kpi',
                component: () => import('@/views/pages/KPI/KPI.vue'),
            },
            {
                path: 'kpi-history/:logBookerId',
                name: 'kpi-history',
                component: () => import('@/views/pages/KPI/KPIHistory.vue'),
            },
            {
                path: 'kpi-settings',
                name: 'kpi-settings',
                meta: {
                    title: 'KPI Settings',
                },
                component: () => import('@/views/pages/KpiCalculation/KpiSettings.vue'),
            },
            {
                path: 'kpi-statistics',
                name: 'kpi-statistics',
                meta: {
                    title: 'KPI Statistics',
                },
                component: () => import('@/views/pages/KpiCalculation/KpiStatistics.vue'),
            },
            {
                path: 'kpi-adjustments',
                name: 'kpi-adjustments',
                meta: {
                    title: 'KPI Bonuses & Charges',
                },
                component: () => import('@/views/pages/KpiCalculation/KpiAdjustments.vue'),
            },
            {
                path: 'kpi-employee/:userId',
                name: 'kpi-employee',
                meta: {
                    title: 'KPI Employee Detail',
                },
                component: () => import('@/views/pages/KpiCalculation/KpiEmployeeDetail.vue'),
            },
            {
                path: 'my-kpi',
                name: 'my-kpi',
                meta: {
                    title: 'My KPI',
                },
                component: () => import('@/views/pages/KpiCalculation/KpiEmployeeDetail.vue'),
            },
            {
                path: 'notes',
                name: 'note-management',
                meta: {
                    title: 'Notes',
                },
                component: () => import('@/views/pages/Notes/NoteManagement.vue'),
            },
            {
                path: 'company-driver-stats',
                name: 'company-driver-stats',
                meta: {
                    title: 'Companies & Drivers Statistics',
                },
                component: () => import('@/views/pages/CompanyDriverStats/CompanyDriverStatistics.vue'),
            },
            {
                path: 'attendance',
                name: 'attendance',
                meta: {
                    title: 'Attendance',
                },
                component: () => import('@/views/pages/Attendance/AttendancePage.vue'),
            },
            {
                path: 'assistant',
                name: 'assistant',
                component: () => import('@/views/pages/Assistant/Assistant.vue'),
            },
            {
                path: 'sales',
                name: 'sales',
                component: () => import('@/views/pages/Sales/Sales.vue'),
            },
            {
                path: 'devices',
                name: 'devices',
                component: () => import('@/views/pages/Sales/Device.vue'),
            },
            {
                path: 'contracts',
                name: 'contracts',
                component: () => import('@/views/pages/Contracts/Contracts.vue'),
            },
            {
                path: 'inspection/violation',
                name: 'inspection-violation',
                component: () => import('@/views/pages/Inspection/Inspection.vue'),
                meta: { inspectionType: 0 },
            },
            {
                path: 'inspection/no-violation',
                name: 'inspection-no-violation',
                component: () => import('@/views/pages/Inspection/Inspection.vue'),
                meta: { inspectionType: 1 },
            },
            {
                path: 'statement',
                name: 'statement',
                meta: {
                    title: 'Statement',
                },
                component: () => import('@/views/pages/Statement/Statement.vue'),
            }
        ],
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/pages/Login.vue')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    let token = cookies.get('token');

    if (to.name !== 'login' && !token) {
        return next({ name: 'login' });
    } else {
        if (token && to.name === 'login') {
            return next('/');
        } else {
            if (hasRoleAccess(Roles.SUPERADMIN) && (to.name === 'home' || to.name === 'main-home')) {
                return next({ name: 'company-driver-stats' });
            }
            const checkerAllowedRoutes = [
                'home', 'worker', 'all-statistics', 'AccessDenied', 'drivers', 'driver-manage',
                'companies', 'company-manage',
                'driver-activity', 'driver-activity-history', 'kpi', 'kpi-history',
                'task-state', 'checker', 'my-kpi'
            ];
            if (hasRoleAccess(Roles.CHECKER) && !checkerAllowedRoutes.includes(to.name as string)) {
                return next({ name: 'home' });
            } else if (to.name == 'checker' && (!hasRoleAccess(Roles.CHECKER) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if (to.name == 'assistant' && (!hasRoleAccess(Roles.ASSISTANT) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if (to.name == 'task-state' && (!hasRoleAccess(Roles.LOGBOOKER) && !hasRoleAccess(Roles.CHECKER) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN) && !hasRoleAccess(Roles.ASSISTANT))) {
                return next({ name: 'home' });
            } else if (to.name == 'driver-activity' && (!hasRoleAccess(Roles.LOGBOOKER) && !hasRoleAccess(Roles.CHECKER) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN) && !hasRoleAccess(Roles.ASSISTANT))) {
                return next({ name: 'home' });
            } else if (to.name == 'driver-activity-history' && (!hasRoleAccess(Roles.LOGBOOKER) && !hasRoleAccess(Roles.CHECKER) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN) && !hasRoleAccess(Roles.ASSISTANT))) {
                return next({ name: 'home' });
            } else if (to.name == 'sales' && (!hasRoleAccess(Roles.SALES) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if (to.name == 'devices' && (!hasRoleAccess(Roles.SALES) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if (to.name == 'kpi' && (hasRoleAccess(Roles.SALES) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if (to.name == 'kpi-history' && (hasRoleAccess(Roles.SALES) && !hasRoleAccess(Roles.MANAGER) && !hasRoleAccess(Roles.SUPERADMIN))) {
                return next({ name: 'home' });
            } else if ((to.name == 'kpi-settings' || to.name == 'kpi-statistics' || to.name == 'kpi-adjustments' || to.name == 'kpi-employee' || to.name == 'note-management' || to.name == 'company-driver-stats' || to.name == 'attendance' || to.name == 'statement') && !hasRoleAccess(Roles.SUPERADMIN)) {
                return next({ name: 'home' });
            }
            return next()
        }
    }
});

export default router;
